import {Col, Row, Tabs,} from "antd";
import {faBuildingColumns, faHome, faPhone} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import './styles.scss';
import AddressUpdateRequestListComp from "../../../components/admin/customerRequestsList/addressUpdateRequestsListComp";
import ContactDetailsUpdateRequestListComp
    from "../../../components/admin/customerRequestsList/contactDetailsUpdateRequestsListComp";
import BankAccountDetailsUpdateRequestListComp
    from "../../../components/admin/customerRequestsList/bankAccountDetailsUpdateRequestsListComp";
import ComplaintsUpdateRequestListComp from "../../../components/admin/customerRequestsList/complaintsRequestsListComp";
import OtherRequestListComp from "../../../components/admin/customerRequestsList/otherRequestsListComp";
import React, {useEffect, useState} from "react";
import {requests_side_menu_img} from "../../../../AppImageConst";
import {isAdminAuthorizerUser, isAdminCheckerUser} from "../../../security/KeyclockConfig";
import AddressDetailChangeHistoryComp
    from "../../../components/admin/customerRequestsList/history/addressDetailChangeHistoryComp";
import ContactDetailChangeHistoryComp
    from "../../../components/admin/customerRequestsList/history/contactDetailChangeHistoryComp";
import BankDetailChangeHistoryComp
    from "../../../components/admin/customerRequestsList/history/bankDetailChangeHistoryComp";
import SignatureDetailChangeHistoryComp
    from "../../../components/admin/customerRequestsList/history/signatureDetailChangeHistoryComp";

const TabPane = Tabs;
const CustomerRequestsListPage = () => {
    const [activeKey, setActiveKey] = useState('0');
    const [isCheckerUser, setCheckerUser] = useState(false);
    const [isAuthorizerUser, setAuthorizerUser] = useState(false);
    const [addressChangeActiveKey, setAddressChangeActiveKey] = useState('1');
    const [contactDetailChangeActiveKey, setContactDetailChangeActiveKey] = useState('1');
    const [bankDetailChangeActiveKey, setBankDetailChangeActiveKey] = useState('1');

    const handleTabChange = (key: string) => {
        setActiveKey(key);
    };

    useEffect(() => {
        let adminCheckerUser = isAdminCheckerUser();
        let adminAuthorizerUser = isAdminAuthorizerUser();
        setActiveKey(adminAuthorizerUser ? "1" : adminCheckerUser ? "4" : "0")
        setCheckerUser(adminCheckerUser)
        setAuthorizerUser(adminAuthorizerUser)
    }, []);

    const handleAddressChangeTabChange = (key: string) => {
        setAddressChangeActiveKey(key);
    };

    const handleContactDetailChangeTabChange = (key: string) => {
        setContactDetailChangeActiveKey(key);
    };
    const handleBankDetailChangeTabChange = (key: string) => {
        setBankDetailChangeActiveKey(key);
    };
    return (
        <div>
            {/*<Spin spinning={isSpinnerLoading} tip="Loading" size="large">*/}

            <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className='page-header-main-title-col'>
                    <h2 className='page-header-main-title'
                        style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                        <div className='header_icon header-icon-center'>
                            <img src={requests_side_menu_img} style={{width: 22, height: 22}} alt=""/>
                        </div>
                        Customer Change Requests
                    </h2>
                </Col>
            </Row>

            <Row gutter={[16, 16]} className='' style={{marginTop: 8}}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className='requests-tabs'>
                    <Tabs defaultActiveKey="0" tabPosition={'left'} type={'card'} onChange={handleTabChange}>
                        {isAuthorizerUser ? <>
                                <TabPane key={1} tab={'Address Details Update Requests'}
                                         icon={<FontAwesomeIcon icon={faHome}/>}>
                                    <div className="tabpane-content">
                                        {activeKey === '1' &&
                                            <Row>
                                                <Col xs={24} lg={24} md={24} sm={24} className={"detailed_tab"}>
                                                    <Tabs type="card" activeKey={addressChangeActiveKey}
                                                          defaultActiveKey={['1']}
                                                          onChange={handleAddressChangeTabChange}>
                                                        <TabPane tab={<>Address Details Update Requests</>}
                                                                 key={1}>
                                                            <Row className={"margin_top_5"}>
                                                                <Col lg={24}>
                                                                    <AddressUpdateRequestListComp isFromHst={false}/>

                                                                </Col>
                                                            </Row>
                                                        </TabPane>
                                                        <TabPane tab={<>History</>}
                                                                 key={2}>
                                                            <Row className={"margin_top_5"}>
                                                                <Col lg={24}>
                                                                    {addressChangeActiveKey === '2' &&
                                                                        <AddressDetailChangeHistoryComp/>}
                                                                </Col>
                                                            </Row>
                                                        </TabPane>
                                                    </Tabs>
                                                </Col>
                                            </Row>
                                        }
                                    </div>
                                </TabPane>
                                <TabPane key={2} tab={'Contact Details Update Requests'}
                                         icon={<FontAwesomeIcon icon={faPhone}/>}>
                                    <div className="tabpane-content">
                                        {activeKey === '2' &&
                                            <Row>
                                                <Col xs={24} lg={24} md={24} sm={24} className={"detailed_tab"}>
                                                    <Tabs type="card" activeKey={contactDetailChangeActiveKey}
                                                          defaultActiveKey={['1']}
                                                          onChange={handleContactDetailChangeTabChange}>
                                                        <TabPane tab={<>Contact Details Update Requests</>}
                                                                 key={1}>
                                                            <Row className={"margin_top_5"}>
                                                                <Col lg={24}>
                                                                    <ContactDetailsUpdateRequestListComp/>

                                                                </Col>
                                                            </Row>
                                                        </TabPane>
                                                        <TabPane tab={<>History</>}
                                                                 key={2}>
                                                            <Row className={"margin_top_5"}>
                                                                <Col lg={24}>
                                                                    {contactDetailChangeActiveKey === '2' &&
                                                                        <ContactDetailChangeHistoryComp/>}
                                                                </Col>
                                                            </Row>
                                                        </TabPane>
                                                    </Tabs>
                                                </Col>
                                            </Row>
                                        }

                                    </div>
                                </TabPane>
                                <TabPane key={3} tab={'Bank Details Update Requests'}
                                         icon={<FontAwesomeIcon icon={faBuildingColumns}/>}>
                                    <div className="tabpane-content">
                                        {activeKey === '3' &&
                                            <Row>
                                                <Col xs={24} lg={24} md={24} sm={24} className={"detailed_tab"}>
                                                    <Tabs type="card" activeKey={bankDetailChangeActiveKey}
                                                          defaultActiveKey={['1']}
                                                          onChange={handleBankDetailChangeTabChange}>
                                                        <TabPane tab={<>Bank Details Update Requests</>}
                                                                 key={1}>
                                                            <Row className={"margin_top_5"}>
                                                                <Col lg={24}>
                                                                    <BankAccountDetailsUpdateRequestListComp
                                                                        isFromHst={false}/>

                                                                </Col>
                                                            </Row>
                                                        </TabPane>
                                                        <TabPane tab={<>History</>}
                                                                 key={2}>
                                                            <Row className={"margin_top_5"}>
                                                                <Col lg={24}>
                                                                    {bankDetailChangeActiveKey === '2' &&
                                                                        <BankDetailChangeHistoryComp/>}
                                                                </Col>
                                                            </Row>
                                                        </TabPane>
                                                    </Tabs>
                                                </Col>
                                            </Row>
                                        }

                                    </div>
                                </TabPane>
                            </>
                            :
                            <></>}
                        {isCheckerUser ?
                            <>
                                <TabPane key={4} tab={'Complaints'}
                                         icon={<div className='tab-pane-complaint-icon'></div>}>
                                    <div className="tabpane-content">
                                        {activeKey === '4' && <ComplaintsUpdateRequestListComp/>}

                                    </div>
                                </TabPane>
                                <TabPane key={5} tab={'Other Requests'}
                                         icon={<div className='tab-pane-other-request-icon'></div>}>
                                    <div className="tabpane-content">
                                        {activeKey === '5' && <OtherRequestListComp/>}
                                    </div>
                                </TabPane>
                                <TabPane key={6} tab={'Signature Update History'}
                                         icon={<div className='tab-pane-sign-change-icon'></div>}>
                                    <div className="tabpane-content">
                                        {activeKey === '6' && <SignatureDetailChangeHistoryComp/>}

                                    </div>
                                </TabPane>
                            </>
                            :
                            <></>
                        }
                    </Tabs>

                </Col>
            </Row>
        </div>
    )
}
export default CustomerRequestsListPage